<form [formGroup]="ressourcesForm" novalidate autocomplete="off">
    <div class="bloc-resultat-cnaf padding-bas-10">
            <div [formGroup]="ressourcesForm.controls.rubriquesMontantRecord" class="margin-left-10">
                <ccd-rubrique-montant 
                    *ngFor="let type of typeRessources"
                    name="{{type.code}}"
                    id="{{type.code}}" 
                    libelle="{{type.libelle}}" 
                    montantId="{{type.code}}_montant" 
                    montantPlaceHolder="{{type.placeHolder}}"
                    [montantValidators]="type.validators"
                    [montantMapErreurs]="montantMapErreurs"
                    [rubriqueModel]="dataRessArray.get(type.code)"
                    [disabled]="ressourcesForm.getRawValue().aucunRevenu">
                </ccd-rubrique-montant>
            </div>
        <div class="row">
            <div class="col-sm-12 form-group margin-left-10">
                <label class="label-form-cnaf align-middle-cnaf" for="aucunRevenu_{{profil}}">
                    <ng-cnaf-checkbox
                        formControlName="aucunRevenu"
                        aria-labelledby="aucunRevenu_{{profil}}"
                        name="aucunRevenu_{{profil}}">
                    </ng-cnaf-checkbox>
                    <span id="aucunRevenu_{{profil}}">Aucun revenu</span>
                </label>
            </div>
        </div>
    </div>
</form> 
